import { Helmet } from "react-helmet"

import { Button, Icon } from "@trueskin-web/components"
import { klarnaTextIcon } from "@trueskin-web/theme/icons/klarnaTextIcon"

import { PaymentErrorMessage } from "../payment-error/payment-error-message"

import { useKlarna } from "./use-klarna"

export const Klarna = ({ type, order }) => {
  const {
    mountRef,
    handleSubmit,
    createPaymentSession,
    isCreatePaymentSessionLoading,
    isProcessing,
    error,
  } = useKlarna({
    paymentMethodType: type,
    order,
  })

  return (
    <div>
      <Helmet
        onChangeClientState={(_, { scriptTags }) => {
          if (scriptTags?.length) {
            scriptTags[0].onload = createPaymentSession
          }
        }}
      >
        <script defer src="https://x.klarnacdn.net/kp/lib/v1/api.js" />
      </Helmet>

      <div ref={mountRef} />

      <Button
        data-testid="web-portal-klarna-proceed-payment-btn"
        onClick={handleSubmit}
        isFullWidth
        isLoading={isCreatePaymentSessionLoading || isProcessing}
        isDisabled={error !== null && error !== undefined}
        sx={{
          bg: "klarna",
          borderColor: "klarna",
          "&:hover": {
            bg: "klarnaLight",
            borderColor: "klarnaLight",
          },
          "&:focus, &.focus": {
            borderColor: "klarnaDark",
            bg: "klarnaDark",
          },
          "&:active, &.active": {
            bg: "klarnaDark",
            borderColor: "klarnaDark",
          },
          "&:after": {
            bg: "klarnaDark",
          },
          ":disabled, &[aria-disabled=true]": {
            svg: {
              color: "disabled",
            },
          },
        }}
      >
        <Icon
          icon={klarnaTextIcon}
          color="text"
          sx={{
            width: 64,
          }}
        />
      </Button>

      <PaymentErrorMessage paymentError={error} />
    </div>
  )
}
